import * as types from './constants'

export const openSidebar = () => ({ type: types.OPEN_SIDEBAR })

export const closeSidebar = () => ({ type: types.CLOSE_SIDEBAR })

export const collapseSidebar = () => ({ type: types.COLLAPSE_SIDEBAR })

export const uncollapseSidebar = () => ({ type: types.UNCOLLAPSE_SIDEBAR })
